import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_google_translate.svg';
import Icon, { IconProps } from './icon';

const IconGoogleTranslate = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconGoogleTranslate;
